// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"17abf6d6","611":"e468cf0d","687":"40108b23"}[chunkId] + ".chunk.js";
};